'use client';
import { Box, Button, Grid, ThemeProvider, Typography } from '@mui/material';
import styles from './HomePage.module.scss';
import RouterLink from 'next/link';
import { useTranslation } from 'react-i18next';
import { homeTheme } from '@/types';

const HomePage = () => {
  const { t } = useTranslation();
  return (
    <ThemeProvider theme={homeTheme}>
      <Grid>
        <Grid container spacing={1}>
          <Grid size={{ xs: 10, sm: 8, md: 6, lg: 4 }} offset={{ xs: 1, sm: 2, md: 3, lg: 4 }}>
            <Box className={styles.box} alignItems='center' sx={{ width: 'md', color: 'text.secondary', mb: 5, mt: 1 }}>
              {/* <ThemeProvider theme={theme}>
              <Box sx={{ width: 'md', color: 'text.secondary' }}> */}
              <Typography sx={{ textAlign: 'center' }} variant='h4' className={styles.typography}>
                {t('home.welcome')}
              </Typography>
              {/* </Box> */}
              {/* </ThemeProvider> */}
              <br />
              <Typography variant='subtitle1' sx={{ fontSize: 16 }} className={styles.typography}>
                {t('home.main-banner.para1')}
                <br />
                <br />
                <Box sx={{ textAlign: 'center' }}>
                  <Button
                    component={RouterLink}
                    variant='contained'
                    href='/quiz-options'
                    color='secondary'
                    className={styles.typography}
                    sx={{ justifySelf: 'center', justifyContent: 'center', textAlign: 'center', alignItems: 'center' }}
                  >
                    {t('home.main-banner.button-text')}
                  </Button>
                </Box>

                <br />
                <span>{t('home.main-banner.para2')}</span>
                <br />
                <br />
                <span>{t('home.main-banner.para3')}</span>
                <br />
                <br />
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Box sx={{ display: { xs: 'none', md: 'block' } }}>
          {/* <Hidden only={['xs', 'sm']}> */}

          <Grid container spacing={4}>
            <Grid size={{ md: 4 }} offset={{ md: 2 }}>
              <Box className={styles.textAlignCenter}>
                <img alt='complex' src='/images/count_number.jpg' />
                <br />
                <Typography variant='h4' sx={{ fontSize: 22, textTransform: 'none' }} className={styles.typography}>
                  {t('home.banner1.heading')}
                </Typography>
                <br />
              </Box>
              <Box className={styles.box} sx={{ width: 'md', color: 'text.secondary', mb: 5 }}>
                <Typography variant='subtitle1' sx={{ fontSize: 16 }} className={styles.typography}>
                  {t('home.banner1.paragraph')}
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ md: 4 }}>
              <Box className={styles.textAlignCenter}>
                <img alt='complex' src='/images/cute-little.jpg' />

                <br />
                <Typography variant='h4' sx={{ fontSize: 22, textTransform: 'none' }} className={styles.typography}>
                  {t('home.banner2.heading')}
                </Typography>
              </Box>
              <br />
              <Box className={styles.box} sx={{ width: 'md', color: 'text.secondary', mb: 5 }}>
                <Typography variant='subtitle1' style={{ fontSize: 16 }} className={styles.typography}>
                  {t('home.banner2.paragraph')}
                </Typography>
              </Box>
            </Grid>
          </Grid>
          {/* </Hidden> */}
        </Box>
        <Box sx={{ display: { md: 'none' } }}>
          {/* <Hidden only={['md', 'lg', 'xl']}> */}
          <Grid container>
            <Grid size={{ xs: 1, sm: 3 }} />
            <Grid size={{ xs: 10, sm: 6 }}>
              <Box className={styles.box} alignItems='center' sx={{ width: 'md', color: 'text.secondary', mb: 5 }}>
                <img alt='complex' src='/images/count_number.jpg' />
                <br />
                <Typography variant='h4' style={{ fontSize: 22, textTransform: 'none' }} className={styles.typography}>
                  {t('home.banner1.heading')}
                </Typography>
                <br />
                <Typography variant='subtitle1' style={{ fontSize: 16 }} className={styles.typography}>
                  {t('home.banner1.paragraph')}
                </Typography>
              </Box>
            </Grid>
          </Grid>
          <Grid container>
            <Grid size={{ xs: 1, sm: 3 }} />
            <Grid size={{ xs: 10, sm: 6 }}>
              <Box className={styles.box} sx={{ width: 'md', color: 'text.secondary', mb: 5 }}>
                <img alt='complex' src='/images/cute-little.jpg' />
                <br />
                <Typography variant='h4' style={{ fontSize: 22, textTransform: 'none' }} className={styles.typography}>
                  {t('home.banner2.heading')}
                </Typography>
                <br />
                <Typography variant='subtitle1' style={{ fontSize: 16 }} className={styles.typography}>
                  {t('home.banner2.paragraph')}
                </Typography>
              </Box>
            </Grid>
          </Grid>{' '}
          {/* </Hidden> */}
        </Box>
      </Grid>
    </ThemeProvider>
  );
};

export default HomePage;
